import { useState, useEffect } from 'react';
import axios from 'axios';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

interface AboutProps {
  value: number;
  suffix: string;
  description: string;
}

const About = (): JSX.Element => {
  const theme = useTheme();
  const [viewPortEntered, setViewPortEntered] = useState(false);
  const setViewPortVisibility = (
    isVisible: boolean | ((prevState: boolean) => boolean)
  ) => {
    if (viewPortEntered) {
      return;
    }
    setViewPortEntered(isVisible);
  };

  const [about, setAbout] = useState<AboutProps[]>([]);

  const fetchAbout = () => {
    axios
      .get<AboutProps[]>('http://120.46.135.166:8000/about', {
        headers: {
          Accept: 'application/json',
        },
      })
      .then((response) => {
        setAbout(response.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchAbout();
  }, []);

  return (
    <div id='about'>
      <Box
        sx={{
          paddingTop: 5,
          paddingBottom: 12,
          paddingX: 2,
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Box marginBottom={4}>
          <Typography
            variant='h5'
            align='center'
            color={theme.palette.text.primary}
            fontWeight={700}
            marginTop={theme.spacing(1)}
            gutterBottom
            sx={{
              textTransform: 'uppercase',
              marginBottom: 2,
            }}
          >
            关于我们
          </Typography>
          <Box marginLeft={3} marginRight={3} maxWidth="100%" sx={{ wordBreak: 'break-word' }}>
          <Typography
            variant='subtitle1'
            align='left'
            color={theme.palette.text.secondary}
            marginTop={theme.spacing(1)}
            gutterBottom
            sx={{
              fontSize: { xs: '10px', sm: '16px' }, // 在不同屏幕尺寸上调整字体大小
              lineHeight: 1.5,
              margin: theme.spacing(1),
              padding: theme.spacing(1)
            }}
          >
                  ha重庆志向科技有限公司，坐落于重庆市高新技术科技园区-石桥铺，是一家智能化系统集成公司，长期致力于多媒体教学系统、中央集成控制系统、数字会议及同声传译系统、安防监控系统等技术的开发设计销售、安装和调试，为客户提供专业的多层次的行业应用系统解决方案和优质产品。
          
          </Typography>
          </Box>
        </Box>
        <Container>
          <Grid container spacing={4}>
            {about.map((item, i) => (
              <Grid item xs={12} md={4} key={i}>
                <Box
                  component={Card}
                  height={1}
                  display='flex'
                  flexDirection='column'
                  boxShadow={0}
                >
                  <CardContent
                    sx={{
                      padding: { sm: 4 },
                    }}
                  >
                    <Box
                      marginBottom={4}
                      display='flex'
                      flexDirection='column'
                      alignItems='center'
                    >
                      <Typography variant='h4' color='primary' gutterBottom>
                        <Box
                          fontWeight={600}
                          sx={{
                            color:
                              theme.palette.mode === 'dark'
                                ? theme.palette.primary.main
                                : theme.palette.success.dark,
                          }}
                        >
                          <VisibilitySensor
                            onChange={(
                              isVisible:
                                | boolean
                                | ((prevState: boolean) => boolean)
                            ) => setViewPortVisibility(isVisible)}
                            delayedCall
                          >
                            <CountUp
                              duration={2}
                              end={viewPortEntered ? item.value : 0}
                              start={0}
                              suffix={item.suffix}
                            />
                          </VisibilitySensor>
                        </Box>
                      </Typography>
                      <Typography
                        component='p'
                        color={theme.palette.text.secondary}
                      >
                        {item.description}
                      </Typography>
                    </Box>
                  </CardContent>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </div>
  );
};

export default About;
